// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".semantic-ui .video-request-message-container {\n  margin-top: 2rem;\n}\n.semantic-ui .video-request-description {\n  margin: 1.5rem 0 1rem;\n  font-weight: 700;\n  line-height: 1.7;\n}\n", ""]);
// Exports
module.exports = exports;
